module.exports = __webpack_public_path__ + "0c5aac13.png";